import * as React from 'react'
import * as plume from '@ulule/owl-kit-components/next'

import { Container } from '../../_shared/Container'
import teamHuddle from '../assets/hero/team-huddle.png?url'
import styles from './Hero.module.css'

export function Hero(): React.ReactElement {
  return (
    <section className={styles.hero}>
      <Container className={styles.hero__inner}>
        <div className={styles.hero__text}>
          <nav className={styles.hero__breadcrumb} aria-label="Fil d'Ariane">
            <a href="/about/ulule/">À propos</a>
            <span aria-hidden="true">›</span>
            <span className={styles.hero__breadcrumbTag}>L'équipe</span>
          </nav>
          <h1 className={styles.hero__title}>
            Une équipe <span className={styles.hero__titleHighlight}>engagée</span> à vos côtés
          </h1>
          {/* NOTE: If you're re-enabling to Lede, make sure you bring back the title bottom margin to 24px. */}
          {/* <p className={styles.hero__lede}>
            Depuis 2010, une équipe de passionné·es au service des créateurs et des entrepreneurs. Paris +
            Province + World ❤️
          </p> */}
          <div className={styles.hero__actions}>
            <plume.RoundButton as="a" href="#makers" color="black" size="big">
              Ce qui nous anime
            </plume.RoundButton>
            <plume.RoundButton as="a" href="#travailler" color="black" kind="secondary" size="big">
              Travailler chez Ulule
            </plume.RoundButton>
          </div>
        </div>
        <div className={styles.hero__art}>
          <img
            className={styles.hero__image}
            src={teamHuddle}
            alt="L'équipe Ulule réunie"
            width={1254}
            height={1254}
          />
        </div>
      </Container>
    </section>
  )
}
